function add_select_all_behavior_to_email_preferences_form() {
	const unsubscribeAllCheckbox = document.querySelector('.gfield.unsubscribe-all input.gfield-choice-input[type="checkbox"]');
	const checkboxes = document.querySelectorAll('input.gfield-choice-input[type="checkbox"]');

	if (!unsubscribeAllCheckbox || checkboxes.length === 0) {
		return;
	}

	// Unsubscribe all if checked.
	unsubscribeAllCheckbox.addEventListener("click", () => {
		if (unsubscribeAllCheckbox.checked) {
			checkboxes.forEach(checkbox => {
				if (checkbox !== unsubscribeAllCheckbox) {
					checkbox.checked = false;
				}
			});
		}
	});

	// If any other checkbox is checked, un-check the checkbox.
	checkboxes.forEach(checkbox => {
		if (checkbox !== unsubscribeAllCheckbox) {
			checkbox.addEventListener("click", () => {
				if (checkbox.checked) {
					unsubscribeAllCheckbox.checked = false;
				}
			});
		}
	});

}

document.addEventListener("DOMContentLoaded", () => {
	add_select_all_behavior_to_email_preferences_form();
});
